export default __webpack_public_path__ + "static/media/email-in.38bbc0fb.mp3";